import script from "./form_radio.vue?vue&type=script&setup=true&lang=ts"
export * from "./form_radio.vue?vue&type=script&setup=true&lang=ts"

import "./form_radio.vue?vue&type=style&index=0&id=c4eca918&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4eca918"]])

export default __exports__